var map = {
	"./mobile/newsList.vue": [
		"448e",
		"chunk-119afbf8",
		"chunk-f0fb865c"
	],
	"./pc/newsList.vue": [
		"9445",
		"chunk-119afbf8",
		"chunk-5b879f0c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8733";
module.exports = webpackAsyncContext;